import { Arrow, ConvictionIcon, CostumesIcon, HomeIcon, RoundsIcon } from "./icons.js";
import { Box, Button, Container, Grid, Stack, Typography, useTheme } from "@mui/material";
import { HorizontalScrollList } from "../../horizontal-scroll-list/index.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import NextLink from "next/link";
import React from "react";
export const Explainer = ({ children, sectionContainer = {} }) => {
    const { t } = useTranslation("c-common");
    const bgColor = "white";
    const borderColor = "#DED3DE";
    return (React.createElement(Box, { component: "section", id: "explainer", sx: {
            backgroundColor: bgColor,
            boxShadow: "sectionBottom",
            position: "relative",
            zIndex: 5,
            ...sectionContainer,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: {
                pt: { xs: 8, sm: 8, md: 10, lg: 14, xl: 16 },
                pb: 0,
            } },
            children,
            React.createElement(Typography, { variant: "h2" }, t("explainer-headline", "Veranstalte dein eigenes Krimidinner Spiel"))),
        React.createElement(List, { sx: { mt: { xs: 0, sm: 3, md: 4, lg: 6 } } },
            React.createElement(Element, { blob: React.createElement(Blob, { icon: React.createElement(HomeIcon, { borderColor: borderColor }), arrow: true }) }, t("explainer-step-1", "Lade deine Freunde zu einem Krimidinner für Zuhause ein.")),
            React.createElement(Element, { blob: React.createElement(Blob, { icon: React.createElement(CostumesIcon, { borderColor: borderColor }), arrow: true }) }, t("explainer-step-2", "Für einen Abend seid ihr die Hauptverdächtigen in einem spannenden Kriminalfall.")),
            React.createElement(Element, { blob: React.createElement(Blob, { icon: React.createElement(RoundsIcon, { borderColor: borderColor }), arrow: true }) }, t("explainer-step-3", "Während drei Runden kommt ihr der Lösung des Falls Schritt für Schritt näher.")),
            React.createElement(Element, { blob: React.createElement(Blob, { icon: React.createElement(ConvictionIcon, { borderColor: borderColor }) }) }, t("explainer-step-4", "Euer Ziel ist, den Täter oder die Täterin zu überführen, die mit am Tisch sitzt."))),
        React.createElement(Container, { maxWidth: "xl", sx: {
                pt: { xs: 6, lg: 8 },
                pb: { xs: 6, sm: 8, md: 10, lg: 12, xl: 14 },
            } },
            React.createElement(Box, { sx: { display: "flex", justifyContent: "center" } },
                React.createElement(Button, { href: t("url-how-does-it-work", "/wie-funktioniert-ein-krimidinner-fuer-zuhause"), LinkComponent: NextLink, sx: { width: { xs: "100%", sm: "unset" } }, variant: "outlined" }, t("how-does-it-work", "Was ist ein Krimidinner?"))))));
};
const List = ({ children, sx = {} }) => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    if (isXs) {
        return (React.createElement(HorizontalScrollList, { items: 2.35, ordered: true, sx: sx }, children));
    }
    return (React.createElement(Container, { maxWidth: "xl", sx: sx },
        React.createElement(Box, { component: "ol", sx: {
                display: "grid",
                columnGap: theme.spacing(5),
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                px: 0,
            } }, children)));
};
const Element = ({ blob, children }) => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isAtleastLg = useMediaQuery(theme.breakpoints.up("lg"));
    return (React.createElement(Stack, { component: "li", direction: "column", spacing: 0 },
        blob,
        React.createElement(Box, null,
            React.createElement(Typography, { sx: { hyphens: "none" }, textAlign: "center", variant: isAtleastLg || isXs ? "body1" : "body2" }, children))));
};
const Blob = ({ arrow, icon }) => {
    const theme = useTheme();
    const isAtleastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const wrapWithArrow = React.useCallback((n) => (React.createElement(Box, { sx: { position: "relative" } },
        n,
        React.createElement(Box, { sx: {
                position: "absolute",
                top: "50%",
                right: theme.spacing(-5.5),
                transform: `translateY(-50%)${isAtleastLg ? "" : " scale(0.65)"}`,
            } },
            React.createElement(Arrow, null)))), [isAtleastLg, theme]);
    const Icon = React.createElement(Box, { sx: { px: { xs: 0, md: 1, lg: 3 } } }, icon);
    return (React.createElement(Grid, { item: true, xs: 3, sx: { mt: 0, mb: { xs: -2.5, lg: -3.5, xl: -4 } } }, arrow ? wrapWithArrow(Icon) : Icon));
};
//# sourceMappingURL=explainer.js.map